<template>
  <header class="site-header">
    <nav>
      <ul>
        <li v-for="menuLink in menuLinks" :key="menuLink.id">
          <prismic-link :field="menuLink.link">{{ $prismic.richTextAsPlain(menuLink.label) }}</prismic-link>
        </li>
      </ul>
    </nav>
    <router-link to="/" class="logo"><img src="/sensi.svg" class="logo-sensi"/></router-link>
  </header>
</template>

<script>
export default {
  name: 'HeaderPrismic',
  data () {
    return {
      menuContent: [],
      menuLinks: []
    }
  },
  methods: {
    getMenu () {
      //Query to get menu content
      this.$prismic.client.getSingle('menu')
        .then((menuContent) => {
          this.menuContent = menuContent
          this.menuLinks = menuContent.data.menu_links
        })
    },
  },
  created () {
    this.getMenu()
  }
}
</script>

<style>
/* Site header */
.site-header {
  height: 30px;
  padding: 20px 0;
}
.site-header,
.site-header a {
  color: #F9EEE2;
  font-weight: 700;
}

.logo-sensi {
  text-align: center;
  width: 250px;
  height: 150px;
}

.site-header nav a:hover {
  color: #787D69;
}
.site-header .logo {
  display: block;
  text-align: center;
  font-size: 22px;
  font-weight: 900;
}
.site-header nav {
  margin-bottom: 30px;
  text-align: center;
}
.site-header nav ul {
  margin: 0;
  padding: 0;
}
.site-header nav li {
  display: inline-block;
  margin-left: 40px;
}

/* Media Queries */
@media (max-width: 1060px) {
  .site-header {
    padding-left: 20px;
    padding-right: 20px;
  }
}
@media (max-width: 767px) {
  .site-header {
    height: auto;
    position: absolute;
    left: 0;
    right: 0;
  }
  .site-header .logo {
    display: block;
    text-align: center;
  }

  .site-header .logo-sensi {
    text-align: center;
    width: 220px;
    height: 130px;
  }

  .site-header nav {
    float: none;
    text-align: center;
  }
  .site-header nav li {
    display: inline-block;
    margin-left: 10px;
    margin-right: 10px;
  }
}
</style>

